import { forwardRef, StyleProps, Wrap } from '@bonusly/design-system';

import { useIsEnabled } from '../hooks/use-is-enabled';
import { AmountButton } from './tags';
import { HashtagButton } from './tags/hashtag-button';
import { RecipientButton } from './tags/recipient-button';

export type ActionTagsProps = StyleProps;

/**
 * The top level primary tags for easily adding recipient, amount, and hashtag to an input
 */
export const ActionTags = forwardRef((props: ActionTagsProps, ref) => {
	const showAmountButton = useIsEnabled('amount');

	return (
		<Wrap {...props} ref={ref}>
			<RecipientButton />
			{showAmountButton && <AmountButton />}
			<HashtagButton />
		</Wrap>
	);
});

ActionTags.displayName = 'ActionTags';
